import {
  ArrowRightOutlined,
  CaretDownFilled,
  CaretUpFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import { Badge, Button, Card, List, Radio } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAsyncEffect } from "use-async-effect";
import reportService from "../../../services/report.service";
import "../home/home.scss";

interface Props {
  init: boolean;
}

const ShopOrderReport: React.FC<Props> = ({ init }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [shops, setShops] = useState<any[]>([]);
  const [shopId] = useState<string>("all");
  const [period, setPeriod] = useState<string>("7");
  const [sortType, setSortType] = useState<string>("asc");
  const [limit] = useState<number>(5);

  const handlePeriodChange = (event: any) => {
    setPeriod(event.target.value);
  };

  const handleSortTypeChange = (event: any) => {
    setSortType(event.target.value);
  };

  const getShopOrderReport = async () => {
    setLoading(true);
    const response = await reportService.getShopOrderReport(
      shopId,
      period,
      sortType,
      limit,
    );
    setShops(response.shops || []);
    setLoading(false);
  };

  useAsyncEffect(async () => {
    getShopOrderReport();
  }, [period, sortType]);

  useAsyncEffect(async () => {
    getShopOrderReport();
  }, []);

  return (
    <Card
      className="dashboard-card"
      title={
        <div className="widget-header">
          <span className="widget-title">Shops Order Report</span>
          <div className="widget-actions">
            <Button
              onClick={getShopOrderReport}
              icon={<ReloadOutlined />}
              disabled={loading}
              size="small"
            />
            <Link to="/shops">
              <Button icon={<ArrowRightOutlined />} size="small" />
            </Link>
          </div>
        </div>
      }
    >
      <List
        className="premium-list"
        size="small"
        header={
          <div
            className="actions"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <Radio.Group
              className="segment-control"
              value={period}
              size="small"
              onChange={handlePeriodChange}
            >
              <Radio.Button value="1">Day</Radio.Button>
              <Radio.Button value="7">Week</Radio.Button>
              <Radio.Button value="30">Month</Radio.Button>
              <Radio.Button value="all">All</Radio.Button>
            </Radio.Group>

            <Radio.Group
              className="segment-control"
              value={sortType}
              size="small"
              onChange={handleSortTypeChange}
            >
              <Radio.Button value="asc">
                <CaretDownFilled />
              </Radio.Button>
              <Radio.Button value="desc">
                <CaretUpFilled />
              </Radio.Button>
            </Radio.Group>
          </div>
        }
        footer={
          <div className="list-info">
            <i>
              Order count{" "}
              {period === "all"
                ? "of all time"
                : period === "1"
                  ? "in last 24 hours"
                  : "in the last " + period + " days"}
            </i>
          </div>
        }
        loading={loading}
        dataSource={shops}
        locale={{ emptyText: "No shop report data found." }}
        renderItem={(item) => (
          <List.Item
            className={item.status}
            actions={[
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <Badge
                  count={item.total_amount?.toFixed(2) + " TL"}
                  className="price-badge"
                />
                <b className="order-count">{item.order_count}</b>
              </span>,
            ]}
          >
            <div>
              <b>{item.o_shopName}</b>
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ShopOrderReport;
